export const aciBand = {
    iconName: 'band',
    svgDef: {
        attr: { fill: 'none', viewBox: '0 0 28 27' },
        path: [
            {
                attr: {
                    d: 'M9.451 18.89c-5.3-4.147-8.068-9.162-6.302-11.42l3.013-3.85a.444.444 0 11.7.548c-1.256 1.606.915 6.076 6.15 10.172 5.234 4.095 10.096 5.127 11.352 3.521a.444.444 0 11.7.548l-3.013 3.85c-1.766 2.258-7.3.778-12.6-3.369zm-3.8-13.174L3.85 8.018c-1.257 1.606.914 6.077 6.149 10.172 5.234 4.096 10.096 5.128 11.352 3.522l1.801-2.302c-2.546.374-6.684-1.237-10.689-4.37C8.46 11.907 5.9 8.277 5.65 5.716z',
                    fill: 'currentColor',
                },
            },
            {
                attr: {
                    d: 'M6.08 7.224a.445.445 0 01-.147-.207c-.48-1.417-.4-2.592.23-3.397 1.205-1.542 4.125-1.407 7.811.359a2.77 2.77 0 011.502 1.877 2.835 2.835 0 01-.53 2.404c-.863 1.104-2.352 1.425-3.555.784-1.869-.996-3.67-1.61-5.074-1.727a.444.444 0 01-.237-.093zm7.855-2.23a1.906 1.906 0 00-.346-.214c-3.183-1.526-5.824-1.766-6.727-.612-.49.626-.387 1.548-.171 2.294 1.483.181 3.244.799 5.118 1.797.822.438 1.84.217 2.422-.527.383-.49.516-1.092.38-1.674-.101-.429-.34-.8-.676-1.063zM21.586 19.355a.444.444 0 01-.147-.207c-.425-1.252-1.325-2.697-2.602-4.176-.892-1.033-.937-2.553-.106-3.615a2.81 2.81 0 012.23-1.084c.884.001 1.701.402 2.244 1.1 2.299 2.956 2.994 5.586 1.859 7.036-.63.805-1.75 1.164-3.242 1.04a.444.444 0 01-.236-.094zm.575-7.78a1.943 1.943 0 00-1.2-.413 1.926 1.926 0 00-1.53.743c-.57.728-.537 1.773.078 2.486 1.26 1.458 2.177 2.9 2.67 4.189.775.03 1.695-.092 2.185-.719.854-1.091.14-3.369-1.86-5.942a1.977 1.977 0 00-.343-.345z',
                    fill: 'currentColor',
                },
            },
            {
                attr: {
                    'fill-rule': 'evenodd',
                    'clip-rule': 'evenodd',
                    d: 'M9.574 11.219a.456.456 0 01.078.64L6.78 15.532a.457.457 0 01-.72-.563l2.874-3.672a.456.456 0 01.641-.078zm7.5 5.867a.456.456 0 01.077.64L14.278 21.4a.457.457 0 01-.719-.562l2.873-3.673a.457.457 0 01.641-.078z',
                    fill: 'currentColor',
                },
            },
        ],
    },
};
